export default __webpack_public_path__ + "static/media/march-2018.a60ad5a1.csv";